import { IconSVG } from '../types';

export const PhoneVertical = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 41 39"
    style={style}
  >
    <path
      fill="currentColor"
      d="M12.679 37.904q-1.263 0-2.138-.847a2.77 2.77 0 0 1-.875-2.069V6.948q0-1.222.875-2.068t2.138-.847h15.64q1.264 0 2.139.847.875.846.875 2.069v28.04q0 1.221-.875 2.068t-2.138.847zm-.513-7.63v4.715q0 .186.16.34a.5.5 0 0 0 .353.156h15.64a.5.5 0 0 0 .353-.155.47.47 0 0 0 .16-.341v-4.715zm8.333 4.032q.612 0 1.044-.417.43-.417.43-1.01 0-.592-.43-1.01a1.45 1.45 0 0 0-1.044-.416q-.612 0-1.043.417a1.35 1.35 0 0 0-.431 1.01q0 .59.431 1.009.43.417 1.043.417m-8.333-6.451h16.667V10.888H12.166zm0-19.386h16.667v-1.52a.47.47 0 0 0-.16-.341.5.5 0 0 0-.353-.155H12.679a.5.5 0 0 0-.353.155.47.47 0 0 0-.16.34z"
    />
  </svg>
);

export default PhoneVertical;
